export function descriptorConfig(value: any) {
    return {enumerable: true, writable: true, configurable: true, value: value};
}
